import { render, staticRenderFns } from "./PlatesList.vue?vue&type=template&id=82984038"
import script from "./PlatesList.vue?vue&type=script&lang=js"
export * from "./PlatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports